/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { InspectorLoginParams, LoginResponseData } from '../api/auth/authClient.typings';
import { UserAction, UserActionType } from '../actions/userActions';
import { LocaleId } from '../translation/i18n';
import { RouteId, RouteParam } from '../../router/routes';

export const LOCAL_STORAGE_USER_DATA = 'pks.userData';

export function writeToLocalStorageUserInfo(data: LocalStorageState): void {
    localStorage.setItem(LOCAL_STORAGE_USER_DATA, JSON.stringify(data));
}

export function readFromLocalStorageUserInfo(): LocalStorageState {
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_DATA));
}

export interface UserState {
    isLoading: boolean;
    localeId: LocaleId;
    authData: LoginResponseData;
    lastMonitoringRoute: { routeId: RouteId; params?: Partial<Record<RouteParam, string>> };
    userForRecaptcha: InspectorLoginParams;
}

export type LocalStorageState = Pick<UserState, 'localeId' | 'authData'>;

const initialState: UserState = {
    isLoading: false,
    localeId: LocaleId.En,
    authData: null,
    lastMonitoringRoute: null,
    userForRecaptcha: null,
    ...readFromLocalStorageUserInfo(),
};

function userReducer(state: UserState = initialState, action: UserAction): UserState {
    switch (action.type) {
        case UserActionType.LOGIN_INSPECTOR:
        case UserActionType.LOGIN_OPERATOR:
        case UserActionType.LOGIN_TAXPAYER:
            return {
                ...state,
                isLoading: true,
            };

        case UserActionType.LOGIN_SUCCESS:
            return {
                ...state,
                isLoading: false,
                authData: action.payload,
            };

        case UserActionType.LOGIN_ERROR:
            return {
                ...state,
                isLoading: false,
                authData: null,
            };

        case UserActionType.LOGOUT_USER:
            return {
                ...state,
                authData: null,
                lastMonitoringRoute: null,
            };

        case UserActionType.CHANGE_LOCALE:
            return {
                ...state,
                localeId: action.payload,
            };

        case UserActionType.SAVE_LAST_MONITORING_ROUTE:
            return {
                ...state,
                lastMonitoringRoute: action.payload,
            };

        case UserActionType.VALIDATE_USER_ACTION:
            return {
                ...state,
                userForRecaptcha: action.payload,
            };

        case UserActionType.COMPLETE_VALIDATE_USER_ACTION:
            return {
                ...state,
                userForRecaptcha: null,
            };

        default:
            return state;
    }
}

export default userReducer;
